import { Component, Input, OnInit } from '@angular/core';
import { ApBaseComponent } from 'webcommon/core-ui';
import { FpMessagesCountsResultDto } from 'webcommon/shared';
import { FpMessagesUrgencyDto } from 'webcommon/shared';

@Component({
  selector: 'fp-message-counts',
  styleUrls: ['./fp-message-counts.component.less'],
  templateUrl: './fp-message-counts.component.html',
})
export class FPMessageCountsComponent extends ApBaseComponent implements OnInit {
  @Input() baseId?: string;
  @Input() messageCounts?: FpMessagesCountsResultDto[];
  @Input() messageUrgencies?: FpMessagesUrgencyDto[];

  Id: string;

  constructor() {
    super();
  }

  ngOnInit() {
    this.setId();
    this.load();
  }

  private load() {
    this.loading = false;
  }

  private setId() {
    this.Id = this.baseId + '-message-counts';
  }

}
